import { useMutation } from "@tanstack/react-query";

import { axios } from "../../lib/axios";
import { ORDERS_KEY } from "../../lib/constants";
import { queryClient } from "../../lib/react-query";
import { useNotificationStore } from "../../stores/notifications";


export const cancelOrder = (id: number): Promise<any> => {
  return axios.post(`/order/cancel/${id}`);
};

export const useOrderCancel = () => {
  const { addNotification } = useNotificationStore();

  return useMutation({
    onSuccess: async () => {
      addNotification({
        type: "success",
        title: "Ok",
        message: "Order canceled successfully"
      });
      await queryClient.invalidateQueries({ queryKey: [ORDERS_KEY] });

    },
    mutationFn: cancelOrder
  });
};